export const UPGRADED_USER_EVENT = 'userUpgraded';
